import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { ReactRuntime } from "../react-runtime";
import { StoreContext } from "../hooks/use-store";
import * as ReactPage from "../../../state/react-page";
import { MakeswiftProvider } from "../../../api/react";
function LiveProvider({
  client,
  children,
  rootElements,
  runtime
}) {
  const store = useMemo(
    () => ReactPage.configureStore({
      preloadedState: runtime ? runtime.store.getState() : ReactRuntime.store.getState(),
      rootElements
    }),
    [rootElements, runtime]
  );
  return /* @__PURE__ */ jsx(StoreContext.Provider, { value: store, children: /* @__PURE__ */ jsx(MakeswiftProvider, { client, children }) });
}
export {
  LiveProvider as default
};
//# sourceMappingURL=LiveProvider.js.map